import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function PutBusinessPremises(clientUuid, data) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/businessPremises/' +  data.uuid + "?clientUuid=" + clientUuid, {
            method: 'PUT',
            headers: { 'Authorization' : unHashedJwt.data},
            data: {
                "label": data.label?.trim(),
                "address": data.address?.trim(),
                "description": data.description?.trim(),
                "premises_name": data.premises_name?.trim(),
                "ecommerce": data.ecommerce
            }      
        }).then(
            res => (res)
        ).catch(error => error.response.data),
        "Admin"
    )
}